module.exports = __webpack_public_path__ + "static/media/circleIcon.d222eff4.svg";